import { render, staticRenderFns } from "./newBundledProduct.vue?vue&type=template&id=74d97852&"
import script from "./newBundledProduct.vue?vue&type=script&lang=js&"
export * from "./newBundledProduct.vue?vue&type=script&lang=js&"
import style0 from "./newBundledProduct.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports